import { FaArrowLeft } from "react-icons/fa";
import Footer from "./Footer";
import Header from "./header";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const styles = {
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
  },

  textarea: {
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
    resize: "none",
  },

  pageWrapper: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: "100%",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    background: "#FFFFFF",
    overflowX: "hidden",
  },
  container: {
    width: "80%",
    maxWidth: "1600px",
    margin: "0 auto",
    padding: "40px 0",
    boxSizing: "border-box",
    animation: "fadeIn 0.5s ease-out forwards",
    flex: "1",
    marginTop: "50px",
  },
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
    color: "#64748B",
    marginBottom: "25px",
    flexWrap: "wrap",
  },
  backBtn: {
    background: "white",
    border: "1px solid #E2E8F0",
    padding: "8px 14px",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "600",
    color: "#475569",
    transition: "0.2s",
  },
  grid: { display: "grid", gap: "60px", alignItems: "start" },
  imageSection: { position: "sticky", top: "100px" },
  mainImageWrapper: {
    width: "100%",
    aspectRatio: "1/1",
    background: "white",
    borderRadius: "24px",
    border: "1px solid #F1F5F9",
    position: "relative",
    overflow: "hidden",
    cursor: "crosshair",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    boxShadow: "0 10px 30px -10px rgba(0,0,0,0.05)",
  },
  mainImage: {
    width: "90%",
    height: "90%",
    objectFit: "contain",
    transition: "transform 0.1s ease-out",
    pointerEvents: "none",
  },
  thumbGrid: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  thumb: {
    width: "70px",
    height: "70px",
    borderRadius: "12px",
    border: "1px solid #E2E8F0",
    cursor: "pointer",
    padding: "4px",
    background: "white",
    transition: "0.2s",
    objectFit: "contain",
  },
  thumbActive: {
    borderColor: "#D60000",
    transform: "translateY(-2px)",
    boxShadow: "0 4px 10px rgba(214, 0, 0, 0.2)",
  },
  brandBadge: {
    background: "#FEF2F2",
    color: "#D60000",
    padding: "6px 12px",
    borderRadius: "30px",
    fontSize: "11px",
    fontWeight: "800",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    width: "fit-content",
    marginBottom: "15px",
  },
  title: {
    fontSize: "36px",
    fontWeight: "800",
    color: "#0F172A",
    lineHeight: "1.2",
    marginBottom: "15px",
  },
  priceBlock: {
    display: "flex",
    alignItems: "baseline",
    gap: "12px",
    marginBottom: "25px",
    paddingBottom: "25px",
    borderBottom: "1px solid #F1F5F9",
    flexWrap: "wrap",
  },
  price: { fontSize: "42px", fontWeight: "800", color: "#0F172A" },
  mrp: {
    fontSize: "20px",
    textDecoration: "line-through",
    color: "#94A3B8",
    fontWeight: "500",
  },
  discountTag: {
    background: "#DCFCE7",
    color: "#166534",
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  configHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
  },
  configLabel: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#64748B",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  moqBadge: {
    fontSize: "12px",
    fontWeight: "700",
    color: "#B91C1C",
    background: "#FEF2F2",
    padding: "4px 10px",
    borderRadius: "6px",
    border: "1px solid #FECACA",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  configGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
    gap: "15px",
    marginBottom: "30px",
  },
  configCard: {
    border: "1px solid #E2E8F0",
    borderRadius: "16px",
    padding: "20px 10px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    position: "relative",
    background: "white",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center",
    textAlign: "center",
  },
  configActive: {
    borderColor: "#D60000",
    background: "#FFF5F5",
    boxShadow: "0 0 0 1px #D60000",
    transform: "translateY(-2px)",
  },
  confName: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#0F172A",
    lineHeight: "1.3",
  },
  confPrice: { fontSize: "15px", color: "#D60000", fontWeight: "800" },
  checkIcon: {
    position: "absolute",
    top: "8px",
    right: "8px",
    color: "#D60000",
    fontSize: "14px",
    background: "white",
    borderRadius: "50%",
  },
  actionArea: {
    display: "flex",
    gap: "15px",
    marginTop: "20px",
    marginBottom: "30px",
    alignItems: "stretch",
    flexWrap: "wrap",
  },
  qtyBox: {
    display: "flex",
    alignItems: "center",
    background: "#F8FAFC",
    borderRadius: "12px",
    border: "1px solid #E2E8F0",
    padding: "0 5px",
  },
  qtyBtn: {
    width: "40px",
    height: "100%",
    background: "transparent",
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
    color: "#475569",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  qtyVal: {
    width: "30px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "18px",
    color: "#0F172A",
  },
  cartBtn: {
    flex: 1,
    background: "#D60000",
    color: "white",
    border: "none",
    borderRadius: "14px",
    fontSize: "18px",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    boxShadow: "0 8px 20px -5px rgba(214, 0, 0, 0.4)",
    transition: "0.2s",
    padding: "16px",
    minWidth: "200px",
  },
  trustGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px",
    background: "#F8FAFC",
    padding: "25px",
    borderRadius: "20px",
    border: "1px solid #E2E8F0",
  },
  trustItem: { display: "flex", gap: "12px", alignItems: "flex-start" },
  trustIcon: {
    color: "#D60000",
    fontSize: "22px",
    marginTop: "2px",
    flexShrink: 0,
  },
  trustTitle: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#0F172A",
    lineHeight: "1.4",
  },
  trustSub: { fontSize: "12px", color: "#64748B" },
  tabs: {
    display: "flex",
    gap: "40px",
    borderBottom: "2px solid #F1F5F9",
    marginTop: "60px",
    marginBottom: "40px",
    overflowX: "auto",
    paddingBottom: "2px",
  },
  tabItem: {
    paddingBottom: "15px",
    cursor: "pointer",
    fontWeight: "600",
    color: "#94A3B8",
    position: "relative",
    fontSize: "16px",
    background: "none",
    border: "none",
    whiteSpace: "nowrap",
    transition: "0.2s",
  },
  tabActive: {
    color: "#D60000",
    borderBottom: "3px solid #D60000",
    marginBottom: "-2px",
  },
  specContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "30px",
  },
  specCard: {
    background: "white",
    padding: "30px",
    borderRadius: "20px",
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 10px rgba(0,0,0,0.02)",
  },
  specHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "25px",
    paddingBottom: "15px",
    borderBottom: "2px solid #F1F5F9",
  },
  specIconBox: {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    background: "#FEF2F2",
    color: "#D60000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
  },
  specTitle: { fontSize: "17px", fontWeight: "800", color: "#0F172A" },
  specRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "14px",
    fontSize: "14px",
    borderBottom: "1px dashed #F1F5F9",
    paddingBottom: "10px",
  },
  specLabel: {
    color: "#64748B",
    fontWeight: "600",
    textTransform: "capitalize",
  },
  specValue: { fontWeight: "700", color: "#334155", textAlign: "right" },
  card: {
    background: "white",
    padding: "35px",
    borderRadius: "24px",
    border: "1px solid #F1F5F9",
    marginBottom: "20px",
  },
  reviewCard: {
    borderBottom: "1px solid #F1F5F9",
    paddingBottom: "25px",
    marginBottom: "25px",
  },
  reviewHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  reviewUser: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontWeight: "700",
    color: "#334155",
  },
};

const TermsAndConditions = ({ onBack }) => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Terms and Conditions | CGRMART</title>
        <meta
          name="description"
          content="Read the Terms and Conditions of CGRMART. Learn about usage policies, intellectual property rights, and legal terms."
        />
        <meta
          name="keywords"
          content="terms and conditions, CGRMART policies, website terms, legal terms India"
        />
        <meta name="robots" content="index, follow" />
        {/* Open Graph */}
        <meta property="og:title" content="Terms and Conditions | CGRMART" />
        <meta
          property="og:description"
          content="Understand the terms and conditions for using CGRMART services."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://cgrmart.com/terms-conditions"
        />
        {/* Twitter */}
        <meta name="twitter:title" content="Terms and Conditions | Tucker EV" />
        <meta
          name="twitter:description"
          content="Tucker EV privacy and data protection policy."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://cgrmart.com/terms-conditions" />
      </Helmet>

      <Header />
      <div style={styles.pageWrapper}>
        <div style={styles.container}>
          <div style={styles.breadcrumb}>
            <button
              onClick={() => {
                navigate("/");
              }}
              style={styles.backBtn}
            >
              <FaArrowLeft /> Back
            </button>
          </div>
          <div className="max-w-4xl mx-auto p-6 text-gray-800">
            <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>

            <p className="mb-4">
              These terms and conditions govern your use of CGRMART. By
              accessing this website, you must accept these terms and conditions
              in full. If you disagree with these terms and conditions or any
              part of them, you should not use this website.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              1. Intellectual Property Rights
            </h2>
            <p className="mb-2">
              1.1. Unless otherwise stated, Tucker owns the intellectual
              property rights in the website and material on the website.
            </p>
            <p className="mb-4">
              1.2. Subject to the license below, all these intellectual property
              rights are reserved.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              2. License to Use Website
            </h2>
            <p className="mb-2">
              2.1. You may view, download for caching purposes only, and print
              pages from the website for your own personal use, subject to the
              restrictions set out below.
            </p>
            <div className="mb-4">
              <p className="mb-2">2.2. You must not:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>
                  Republish material from this website (including republication
                  on another website).
                </li>
                <li>Sell, rent, or sub-license material from the website.</li>
                <li>Show any material from the website in public.</li>
                <li>
                  Reproduce, duplicate, copy, or exploit material for commercial
                  purposes.
                </li>
                <li>Edit or modify any material on the website.</li>
              </ul>
            </div>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              3. Acceptable Use
            </h2>
            <p className="mb-2">
              3.1. You must not use this website in any way that causes damage
              to the website or impairs availability or accessibility, or in any
              unlawful or harmful way.
            </p>
            <p className="mb-4">
              3.2. You must not use this website to distribute malicious
              software including spyware, viruses, Trojan horses, worms, or
              similar threats.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              4. Limitations of Liability
            </h2>
            <p className="mb-2">
              4.1. CGRMART will not be liable for any loss or damage arising
              from the use of this website.
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li>For any direct loss (if the website is free).</li>
              <li>For any indirect or consequential loss.</li>
              <li>For business losses, loss of revenue, or data loss.</li>
            </ul>
            <p className="mb-4">
              4.2. These limitations apply even if CGRMART has been advised of
              potential losses.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">5. Variation</h2>
            <p className="mb-4">
              CGRMART may revise these terms from time to time. Updated terms
              will apply from the date they are published on this website.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              6. Entire Agreement
            </h2>
            <p className="mb-4">
              These terms constitute the entire agreement between you and Tucker
              Motors and supersede all previous agreements.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">
              7. Law and Jurisdiction
            </h2>
            <p className="mb-2">
              These terms are governed by applicable laws, and any disputes will
              be handled under the appropriate jurisdiction.
            </p>
            <p className="mb-2">
              7.2. If you have questions, please contact us through the website.
            </p>
            <p className="mb-4">
              7.3. By using this website, you agree to these terms in full.
            </p>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default TermsAndConditions;
